import { DocumentItem, Icon, Span } from "@virtual-brain-lib/frontend-design-system/ui";
import type { MessageToolAnalysisDocument, MessageToolStepStatus } from "@virtual-brain-lib/types";

export function AnalysisDocumentRow({
	document,
	onDocumentClick,
}: {
	readonly document: MessageToolAnalysisDocument;
	readonly onDocumentClick?: (doc: MessageToolAnalysisDocument) => void;
}) {
	const showStatusText = document.status === "processing" && Boolean(document.statusText);

	return (
		<div className="flex min-w-0 flex-wrap items-center gap-x-1.5">
			<div className="flex max-w-full min-w-0 items-center gap-1.5">
				<AnalysisDocumentRowStatusIcon status={document.status} />
				<DocumentItem
					className="min-w-0 flex-1"
					mimeType={document.mimeType}
					name={document.name}
					onClick={
						onDocumentClick
							? () => {
									onDocumentClick(document);
								}
							: undefined
					}
				/>
			</div>
			{showStatusText && (
				<Span
					className="block max-w-full min-w-0 truncate italic"
					color="defaultLight"
					variant="body-xs"
				>
					{document.statusText}
				</Span>
			)}
		</div>
	);
}

function AnalysisDocumentRowStatusIcon({ status }: { readonly status: MessageToolStepStatus }) {
	if (status === "queued") {
		return (
			<span className="flex size-3 shrink-0 items-center justify-center">
				<span className="size-1 rounded-full bg-default/65" />
			</span>
		);
	}

	return (
		<Icon
			className="shrink-0"
			color="defaultLight"
			name={status === "processing" ? "spinner" : "circleCheck"}
			size="sm"
		/>
	);
}
